/* eslint-disable react/no-array-index-key */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';

import { I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import moment from 'moment-timezone';
import PanelSidebar from '../components/panel/PanelSidebar';
import { appendScript, removeScript, scrollToTopAnimated } from '../components/utils';

import ROUTES from '../data/routes';
import PanelAction from '../app/store/actions/panel';
import { cartsCopy } from '../app/store/actions/cart';
import PUCHASES from '../data/purchases';
import { history } from '../routers/AppRouter';
import PriceComponent from '../components/price/Price';

class OrderListPage extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      limit: 10,
      skip: 0,
      showModal: false,
      orderId: '',
      filterByStatus: PUCHASES.ordersAndEstimatesTypes.SHOW_ALL.value,
      filterByContract: props && props.clientId,
    };
  }

  componentDidMount = () => {
    setTimeout(async () => {
      const { clientId } = this.props;
      const { limit, skip, filterByStatus } = this.state;
      await this.props.getOrderList({clientId, limit, skip }, filterByStatus);

      removeScript('/scripts/panel.min.js');
      appendScript('/scripts/panel.min.js');

      scrollToTopAnimated();
    }, 0);
  }

  componentWillUnmount = () => {
    removeScript('/scripts/panel.min.js');
  }

  loadOrders = async (e) => {
    const { clientId } = this.props;
    const { limit, skip, filterByContract } = this.state;
    this.props.getOrderList({ clientId, clients: filterByContract, limit, skip }, e);
    await this.setState({
      filterByStatus: e,
    });
  }

  contractChange = async (e) => {
    const { clientId, contractsClientIds } = this.props;
    const { limit, skip, filterByStatus } = this.state;
    this.props.getOrderList({ clientId, clients: e, limit, skip }, filterByStatus);
    await this.setState({
      filterByContract: e == '' ? contractsClientIds : e,
    });
  }

  orderStatus = (status) => {
    if (status === PUCHASES.orderStatus.CONFIRMED) return I18n.t('done');
    if (status === PUCHASES.orderStatus.PAID) return I18n.t('paid');
    if (status === PUCHASES.orderStatus.PROCESSED) return I18n.t('paid');
    if (status === PUCHASES.orderStatus.DELIVERED) return I18n.t('details2');
    if (status === PUCHASES.orderStatus.INVOICES_ISSUED) return I18n.t('paid');
    if (status === PUCHASES.orderStatus.INVOICES_ISSUED_PARTIALLY) return I18n.t('paid');
    if (status === PUCHASES.orderStatus.CANCELED) return I18n.t('canceled');
  }

  paymentType = (payment) => {
    if (payment === PUCHASES.paymentType.CREDIT) return I18n.t('credit');
    if (payment === PUCHASES.paymentType.DEBIT) return I18n.t('debit');
    if (payment === PUCHASES.paymentType.BANK_SLIP) return I18n.t('bankSlip');
    if (payment === PUCHASES.paymentType.BILLING) return I18n.t('billing');
    if (payment === PUCHASES.paymentType.ESTIMATE) return I18n.t('estimate');
  }

  paymentStatus = (payment) => {
    if (payment === PUCHASES.paymentStatus.INDEFINITE) return I18n.t('undefined');
    if (payment === PUCHASES.paymentStatus.AUTHORIZED) return I18n.t('authorized');
    if (payment === PUCHASES.paymentStatus.NOT_AUTHORIZED) return I18n.t('notAuthorized');
    if (payment === PUCHASES.paymentStatus.CANCELED) return I18n.t('canceled');
    if (payment === PUCHASES.paymentStatus.CAPTURED) return I18n.t('captured');
  }

  copyCart = async () => {
    const { orderId } = this.state;
    this.setState({ showModal: false });
    await this.props.copyCart(orderId);
    history.push(ROUTES.CART);
  }


  isInvocesIssued = (order) => {
    if (order.paymentType === PUCHASES.paymentType.ESTIMATE) return false;
    if ([PUCHASES.orderStatus.INVOICES_ISSUED, PUCHASES.orderStatus.FINISHED,
      PUCHASES.orderStatus.DELIVERED].indexOf(order.status) !== -1) return I18n.t('invoiceIssued');
    if (order.status === PUCHASES.orderStatus.INVOICES_ISSUED_PARTIALLY) return I18n.t('invoiceIssuedPartially');
    return false;
  }

  getList = orderList => orderList.map((order) => {
    const date = moment(order.createdAt);
    const day = date.format('DD');
    const month = date.format('MMM');

    let status = this.orderStatus(order && order.status);
    const isInvocesIssued = this.isInvocesIssued(order);
    if (isInvocesIssued) status = `${status} (${isInvocesIssued})`;

    return (
      <Link
        key={order.id}
        to={{ pathname: ROUTES.ORDER_DETAILS, search: `?query=${order.id}`, state: 'hellow' }}
        className="requests-item"
        style={{ textDecoration: 'none' }}
      >
        <div className="date">
          <strong>{day}</strong>
          {' '}
          <span className="line" />
          {' '}
          {month}
        </div>
        <div className="content">
          {this.state.filterByContract && this.state.filterByContract === "*" && (
            <span className="content-item">
              <strong>{I18n.t('name')}</strong>
              {': '}
              {order['client.nickname']}
            </span>
          )}
          <span className="content-item">
            <strong>{I18n.t('code2')}</strong>
            {' '}
            {order.id}
          </span>
          {!!order.sphereNumber && (
            <span className="content-item">
              <strong>{I18n.t('codeSphere')}</strong>
              {' '}
              {order.sphereNumber}
              {!!order.savedId && (
                <React.Fragment>
                  {' | '}
                  <strong>{I18n.t('documentStatus3')}</strong>
                  {' '}
                  {order.savedId}
                </React.Fragment>
              )}
            </span>
          )}
          <span className="content-item">
            <strong>{I18n.t('paymentType2')}</strong>
            {' '}
            {this.paymentType(order.paymentType)}
            {(order && order.status && status && order.paymentType !== PUCHASES.paymentType.ESTIMATE) && (
              <React.Fragment>
                {' | '}
                <strong>{I18n.t('documentStatus3')}</strong>
                {' '}
                {status}
              </React.Fragment>
            )}
          </span>
          {order.paymentType !== PUCHASES.paymentType.ESTIMATE && (
            <span className="content-item">
              <strong>{I18n.t('price2')}</strong>
              {' '}
              <PriceComponent value={Number(order.value)} />
            </span>
          )}
          <span className="content-item">
            <strong>{I18n.t('buyDate2')}</strong>
            {' '}
            {date.format('LLL')}
          </span>
          {order['solicitationUser.email'] && (
            <span className="content-item">
              <strong>{I18n.t('orderSolicitedBy')}</strong>
              {' '}
              {order['solicitationUser.email']}
            </span>
          )}
          {order['user.email'] && (
            <span className="content-item">
              <strong>{I18n.t('orderMadeBy')}</strong>
              {' '}
              {order['user.email']}
            </span>
          )}
          {this.props.cartUsersPermission && (
            <button
              type="button"
              className="btn cursorPointer"
              onClick={(e) => {
                e.preventDefault();
                this.setState({ orderId: order.id, showModal: true });
              }}
            >
              {I18n.t('copyOrder')}
            </button>
          )}
        </div>
      </Link>
    );
  })

  renderModalCopy = showModal => (
    <div
      className="modal"
      style={{ display: showModal ? 'block' : 'none' }}
      onClick={() => {
        this.setState({ showModal: false, orderId: '' });
      }}
      role="presentation"
    >
      <div className="modal-content">
        <div className="modal-body">
          <div className="column body-modal-text">
            <h3 className="h3-modal-div">{I18n.t('wishToCopyOrder')}</h3>
            <h4 className="h4-modal-div">{I18n.t('currentCartWillChange')}</h4>
          </div>
          <div className="row body-modal-div">
            <button
              type="button"
              className="btn"
              onClick={() => this.setState({ showModal: false, orderId: '' })}
            >
              {I18n.t('cancel')}
            </button>
            <button
              type="button"
              className="btn"
              onClick={() => this.copyCart()}
            >
              {I18n.t('copyOrder')}
            </button>
          </div>
        </div>
      </div>
    </div>
  )

  render() {
    const { orderList, contracts } = this.props;
    const { showModal } = this.state;

    return (
      <main>
        <div className="section section-panel">
          <div className="container">
            <h1 className="panel-title">{I18n.t('documentList2')}</h1>

            <div className="panel-content">

              <PanelSidebar />

              <div className="box-content requests">
                <div className="requests-header">                  
                  {contracts && contracts.length > 0 && <div className="filter">
                    <label>
                      {I18n.t('filterByContract')}
                      <div className="select select--white">
                        <select
                          name="filterByContract"
                          value={this.state.filterByContract}
                          onChange={e => this.contractChange(e.target.value)}
                        >
                          <option
                              key={`filterBy_${-1}`}
                              value={'*'}
                            >
                              {I18n.t('all')}
                          </option>

                          {Object.keys(contracts).map((item, index) => (
                            <option
                              key={`filterBy_${index}`}
                              value={contracts[index].clientId}
                            >                              
                              {I18n.t(contracts[index].clientDetails && contracts[index].clientDetails.nickname)}
                            </option>
                          ))}
                        </select>
                      </div>
                    </label>
                  </div>}
                  <div className="filter">
                    <label>
                      {I18n.t('filterByStatus')}
                      <div className="select select--white">
                        <select
                          name="filterByStatus"
                          value={this.state.filterByStatus}
                          onChange={e => this.loadOrders(e.target.value)}
                        >
                          {Object.keys(PUCHASES.ordersAndEstimatesTypes).map((item, index) => (
                            <option
                              key={`${PUCHASES.ordersAndEstimatesTypes[item].label}${index}`}
                              value={PUCHASES.ordersAndEstimatesTypes[item].value}
                            >
                              {I18n.t(PUCHASES.ordersAndEstimatesTypes[item].label)}
                            </option>
                          ))}
                        </select>
                      </div>
                    </label>
                  </div>
                  <a
                    className="btn cursorPointer"
                    onClick={() => this.props.getConsumption(this.state.filterByContract)}
                    role="presentation"
                  >
                    {I18n.t('generateSummary')}
                  </a>
                </div>

                {orderList && orderList.length > 0
                  ? this.getList(orderList)
                  : (
                    <p>
                      {I18n.t('noneDocument')}
                    </p>
                  )
                }

              </div>

            </div>

          </div>
          {this.renderModalCopy(showModal)}
        </div>
      </main>
    );
  }
}

const mapStateToProps = state => ({
  clientId: state.contracts.selected.client.id,
  orderList: state.panel.orderList,
  cartUsersPermission: state.contracts.selected && state.contracts.selected.cartUsersPermission,
  contracts: state.contracts && state.contracts.list,
});

const mapDispatchToProps = dispatch => ({
  getOrderList: (data, filterBy) => dispatch(PanelAction.getOrderList(data, filterBy)),
  getConsumption: (filteredClients) => dispatch(PanelAction.getConsumption(filteredClients)),
  copyCart: id => dispatch(cartsCopy(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(OrderListPage);
